import { render } from "./SolanaChart.vue?vue&type=template&id=4d3b8b02&ts=true"
import script from "./SolanaChart.vue?vue&type=script&lang=ts"
export * from "./SolanaChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__